import { render, staticRenderFns } from "./ChooseAreaMulti.vue?vue&type=template&id=0d095348&scoped=true"
import script from "./ChooseAreaMulti.vue?vue&type=script&lang=js"
export * from "./ChooseAreaMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d095348",
  null
  
)

export default component.exports